import deriveLinkComponents from '../associations/derive-link-components';
import api from '../REST/api';
import CampaignLink from './CampaignLink';

const { Link, Links } = deriveLinkComponents(CampaignLink, api.getCampaign);

export { Link as CampaignLink, Links as CampaignLinks };
